function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1302.4,484.75c-59.44,11.44-119.55-3.16-178.38-11.42-74.87-10.5-149.47,1.66-223.94,11.3C820.75,494.9,741,506.43,660.79,503.06c-47.51-2-116.94-11.47-122.36-70.5-4.59-50,29.83-102.51,52-144.77,15.18-28.93,54.07-84.73,35.81-119.17-45.48-85.83-271.46,73.87-468.16,36.65C48.74,184.59,7.3,97.44,2,.11",
  fill: "none",
  stroke: "#1d1d1d",
  strokeWidth: 4,
  opacity: 0
});

var SvgCoverSquiggle2 = function SvgCoverSquiggle2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4cdf4fa-fcac-4ab6-808e-68a129492dd9",
    "data-name": "Layer 1",
    width: 1302.78,
    height: 505.66,
    viewBox: "0 0 1302.78 505.66",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoverSquiggle2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cover-squiggle-2.90025a46.svg";
export { ForwardRef as ReactComponent };